import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { mixGetV1 } from 'services/mixin';
import { API_URL, API_USER_URL } from 'env';

const AUTH_ROUTES = ['/login', '/sign-up', '/forget-password', '/reset-password', '/verify-otp'];

export const useAuth = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isReady, setIsReady] = useState(false);
  const token = localStorage.getItem('token');
  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');

  // Handle Google OAuth callback
  useEffect(() => {
    const handleGoogleCallback = async () => {
      if (!code) return;

      try {
        const response = await fetch(`${API_USER_URL}/api/v1/be/google/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code, state: params.get('state') }),
        });

        const data = await response.json();
        if (data.status) {
          localStorage.setItem('token', data.data.access_token);
          const userRes = await fetch(`${API_USER_URL}/api/v1/be/users/${data.data.info.id}` ,{
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${data.data.access_token}`,
            },
          })
          const userResData = await userRes.json();
          if (userResData.status) {
            localStorage.setItem('user', JSON.stringify(userResData.data));
            window.location.reload();
          }
        }
      } catch (error) {
        console.error('Login error:', error);
      }
    };

    handleGoogleCallback();
  }, []);

  // Handle auth redirects
  useEffect(() => {
    const isAuthRoute = AUTH_ROUTES.includes(location.pathname);

    if (!isAuthRoute && !token && !code) {
      navigate('/login');
    } else if (isAuthRoute && token) {
      navigate('/');
    }

    setIsReady(true);
  }, [navigate, location.pathname, token, code]);

  return { isReady };
};
